import React from 'react';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

const WinnerInfo = ({ amount, gameName, loginFormatted }) => (
  <>
    <div className="game-item-label">
      <Label message="Congratulations" />
    </div>
    <div className="game-item-user">
      <span>{loginFormatted}</span>
      <Label className="game-item-user-won" message="won" />
      <span>{amount}</span>
    </div>
    <div className="game-item-name">
      <span>{gameName}</span>
    </div>
  </>
);

WinnerInfo.propTypes = {
  amount: PropTypes.string.isRequired,
  gameName: PropTypes.string.isRequired,
  loginFormatted: PropTypes.string.isRequired,
};

export default WinnerInfo;
